<template>
  <div class="tour-list__result">
    <div class="c-result w-100">
      <div class="result" id="result-content">
        <ResultNav />
        <template v-if="!getLoading">
          <template v-if="results.length">
            <div class="result__items">
              <div class="result__items-wrapper">
                <ResultItem
                  v-for="result in results"
                  :key="result.tourId"
                  :result="result"
                />
              </div>
            </div>

            <Paginate />
          </template>

          <div class="px--2 px-md--0" v-else>
            <NoResult />
          </div>
        </template>

        <div class="px--2 px-md--0" v-else>
          <Loading />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

import ResultItem from "./ResultItem";
import ResultNav from "./ResultNav";
import Loading from "./Loading";
import NoResult from "./NoResult";
import Paginate from "./Paginate.vue";

export default {
  name: "Result",

  components: {
    ResultItem,
    ResultNav,
    Loading,
    NoResult,
    Paginate,
  },

  computed: {
    ...mapState(["results", "showLoadMore", "pageNumber"]),
    ...mapGetters(["getLoading"]),
  },

  methods: {
    ...mapActions({
      updateSort: "updateSort",
      loadMoreResult: "loadMoreResult",
    }),

    changeSort(sortItem) {
      this.updateSort(sortItem.id);
    },

    loadMore() {
      this.loadMoreResult();
    },
  },
};
</script>

<style lang="scss">
@import "../style/modules/_result.scss";
</style>
